import React, { useContext } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import ThemeContext from "../../utils/Contexts/ThemeContext";
import TotalBalance from "./Sections/TotalBalance";
import AppGuide from "./Sections/AppGuide";
import SellerRating from "./Sections/SellerRating";
import NewsAnnouncement from "./Sections/NewsAnnouncement";
import DueAcceptance from "./Sections/DueAcceptance";
import DueCompletion from "./Sections/DueCompletion";
import TopWebsites from "./Sections/TopWebsites";
import Statistics from "./Sections/Statistics";
import RecommendationsBg from "../../images/recommendations-bg.svg";
import OffersBg from "../../images/offers-bg.svg";
import Recommendations from "./Sections/Recommendations";
import UserContext from "../../utils/Contexts/UserContext";
import Constant from "../Constants";

import "./style.css";

function Dashboard() {
  const { t } = useContext(LanguageContext);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);
  const { userData } = useContext(UserContext);

  return (
    <main
      id="content"
      role="main"
      className={`main ${themeStatus?.[selectedTheme]}`}
    >
      <div className="content container-fluid">
        <div
          className="page-header pb-0 mb-4"
          style={{ borderBottom: "unset" }}
        >
          <div className="row">
            <div className="col-md d-md-flex justify-content-between align-items-center mb-sm-2 mb-2 mb-md-0">
              <div>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-no-gutter">
                    <li className="breadcrumb-item">
                      {/* eslint-disable-next-line */}
                      <a
                        className="breadcrumb-link"
                        style={{ fontSize: "18px", fontWeight: "400" }}
                      >
                        {t("Dashboard")}
                      </a>
                    </li>
                  </ol>
                </nav>
                <h1 className="page-header-title">
                  {t("Welcome back")}, {userData?.first_name}{" "}
                  {userData?.last_name}
                </h1>
              </div>
              <div className="d-flex gap-3 mt-5 mt-md-0">
                <button className="btn btn-outline-primary text-center btn-dashboard-knowledge d-flex justify-content-center align-items-center">
                  {t("Knowledge Base")}
                </button>
                <button className="btn btn-outline-primary text-center btn-dashboard-explore d-flex justify-content-center align-items-center">
                  {t("Explore All The Ways")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="mb-4"
          style={{
            borderBottom: `.0625rem solid var(--border)`,
            marginLeft: "-30px",
            marginRight: "-30px",
          }}
        ></div>

        <div className="row px-2 dash-row">
          <div className="col-12 mb-3">
            <AppGuide />
          </div>
          <div className="col-12 mb-3">
            <Statistics />
          </div>
          <div className="col-4-balance mb-3">
            <TotalBalance />
          </div>
          <div className="col-4-rating mb-3">
            <SellerRating />
          </div>
          <div className="col-4-news mb-3">
            <NewsAnnouncement />
          </div>
          <div className="col-1920-3-announcement mb-3">
            <Recommendations
              image={RecommendationsBg}
              title={t("Boost Your Offer's Appeal")}
              subTitle={t(
                "Confirm your website affiliation and perform a test placement to enhance trust and attract more buyers to your offers."
              )}
              links={t("See Recommendations")}
              flag={true}
            />
          </div>
          <div className="col-1920-3-announcement-picks announcement-lg mb-5">
            <Recommendations
              image={OffersBg}
              title={t("Top Picks for You")}
              subTitle={t(
                "Based on your previous searches and purchases, we've handpicked these personalized offers just for you."
              )}
              links={t("See Offers")}
              flag={false}
            />
          </div>
          <div className="col-6-top-websites mb-3">
            <TopWebsites />
          </div>
          <div className="col-1920-3-announcement-picks announcement-sm mb-3">
            <Recommendations
              image={OffersBg}
              title={t("Top Picks for You")}
              subTitle={t(
                "Based on your previous searches and purchases, we've handpicked these personalized offers just for you."
              )}
              links={t("See Offers")}
              flag={false}
            />
          </div>
          <div className="col-6-due-acc mb-3">
            <DueAcceptance />
          </div>
          <div className="col-6-due-comp">
            <DueCompletion />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Dashboard;
